export default __webpack_public_path__ + "static/media/share-alt-white.f09d8064.svg";